import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@mdi/react';
import { mdiCommentQuote } from '@mdi/js';
import Img from "gatsby-image"


export default function CommunityInsights(props) {
  function renderCommunityInsightsData() {
    return (
      <div className="community-insights card mt-4 mb-5">
        <div className="community-insights__head level is-mobile">
          <div className="level-left">
            <h3>Community Insight</h3>
          </div>
          <div className="level-right has-text-grey-dark">
            <Icon path={mdiCommentQuote} title="" size={1.7} />
          </div>
          </div>
          <div className="community-insights__body">
            <div
              className="content"
              dangerouslySetInnerHTML={{ __html: props.insightData.quote }}>
            </div>
          </div>

          <div className="community-insights__bio">
            <div className="community-insights__image">
              {props.insightData.insight_image !== null &&
                <Img fixed={props.insightData.insight_image.childImageSharp.fixed} />
              }
            </div>
            <div className="community-insights__bio-copy">
              <h4 className="community-insights__bio-head">{props.insightData.name}</h4>
              <div className="is-size-6 content" dangerouslySetInnerHTML={{ __html: props.insightData.bio }}></div>
            </div>
          </div>
      </div>
    )
  }

  return (
    <>
      {renderCommunityInsightsData()}
    </>
  )
}

CommunityInsights.defaultProps = {
  insightData: {},
}

CommunityInsights.propTypes = {
  insightData: PropTypes.object,
}
